/// <amd-module name="Test/TestPlansHubRefresh/TestPlansSegment/TestPlansSegmentConstants" />

export namespace FavoriteConstants {
    export const ArtifactType = "Microsoft.TeamFoundation.TestManagement.Plan";
    export const ArtifactScopeType = "Project";
    export const MarkFavorite = "MarkedAsFavorite";
    export const RemoveFavorite = "RemovedAsFavorite";
}

export namespace WorkItemFieldConstants {
    export const StartDate = "Microsoft.VSTS.Scheduling.StartDate";
    export const FinishDate = "Microsoft.VSTS.Scheduling.FinishDate";
    export const AreaPath = "System.AreaPath";
    export const IterationPath = "System.IterationPath";
}

export namespace ProgressReportConstants {
    export const ManualTestAnalyticsHubRouteId = "ms.vss-test-analytics-web.manualtest-analytics-hub-route";
    export const EnableNewAnalyticsHubForManualTestFF = "WebAccess.TestManagement.EnableNewAnalyticsHubForManualTest";
    export const TestResultsReportSummaryCommandName = "ManualTestAnalytics_TestResultsReportSummary";
}

export namespace DateTimeConstants {
    export const DATETIME_MINDATE_UTC_MS = -62135596800000;
    export const Locale = "default";
    export const ShortMonthFormat = "short";
}